import * as AnimatedCarousel from '@components/animated-carousel'
import { useScrollTo } from '@hooks/use-scroll-to'
import { BlockCall } from 'types/block-call'
import { Button } from '../button'
import { useCallback } from 'react'

type Props = {
  data: Array<BlockCall>
  windowWidth: number
}

export const ExperienceSection = ({ data, windowWidth }: Props) => {
  const { scrollToElementWithId } = useScrollTo()

  const handleClick = useCallback(
    () =>
      scrollToElementWithId(windowWidth < 768 ? 'simulation' : 'hero-banner'),
    [windowWidth]
  )
  return (
    <AnimatedCarousel.Root className="gap-8 px-4 md:px-8 sm:gap-12 md:gap-16 lg:gap-20">
      <AnimatedCarousel.Header
        transition={{
          duration: 0.7,
          delay: 0.5
        }}
      >
        <div className="w-full flex flex-col items-center">
          <h2 className="block sm:inline-block bg-clip-text bg-gradient-to-r from-v3-orange-500 to-[#FFC224] text-xl sm:text-[1.75rem] tracking-[-1px] font-bold text-center text-transparent md:text-3xl md:tracking-[-0.5px] 1.5xl:text-[2.1875rem] 1.5xl:tracking-[-0.5px] mb-2 sm:mb-3 w-full sm:w-auto">
            + 20.000 Sistemas Vendidos
          </h2>
          <p className="text-xs sm:text-sm text-v2-eerie-black text-center md:text-base leading-relaxed w-full max-w-full sm:max-w-none">
            Instalações <b>sem surpresas</b> e com{' '}
            <b>
              os melhores
              <br className="hidden sm:block" />
              <span className="sm:hidden"> </span>
              equipamentos{' '}
            </b>
            do mercado
          </p>
        </div>
      </AnimatedCarousel.Header>

      <AnimatedCarousel.Section
        transition={{
          duration: 0.7,
          delay: 0.5
        }}
        className="w-full min-h-[200px] sm:min-h-[280px]"
      >
        {data && data.length > 0 ? (
          <AnimatedCarousel.BlockCallsCarousel data={data} />
        ) : (
          <div className="w-full h-[200px] sm:h-[280px] flex items-center justify-center">
            <p className="text-sm text-gray-400">Carregando projetos...</p>
          </div>
        )}
      </AnimatedCarousel.Section>

      <AnimatedCarousel.Section
        transition={{
          duration: 0.7,
          delay: 1.4
        }}
        className="w-full"
      >
        <div className="w-full flex justify-center">
          <Button
            className="w-full max-w-[20.875rem] mt-8 sm:mt-12 md:mt-6 xl:mt-5 2xl:mt-10 1.5xl:mt-11"
            onClick={handleClick}
          >
            instale energia solar
          </Button>
        </div>
      </AnimatedCarousel.Section>
    </AnimatedCarousel.Root>
  )
}
